import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useMutation } from '@apollo/client';

import { captureException } from '@playbookux/playbook-web-core';
import {
  Container,
  ContainerIcon,
  Text,
  Link,
  IconClose,
} from './styles';

import {
  DISMISS_BANNER,
  GET_BANNERS,
  LIMIT,
} from '../../../graphql';

const Banner = (props) => {
  const {
    id,
    companyId,
    projectName,
    userId,
  } = props;

  const [dismissBanner] = useMutation(DISMISS_BANNER, {
    refetchQueries: [{
      query: GET_BANNERS,
      variables: {
        companyId,
        status: 'in_progress',
        testType: 'moderated',
        userId,
        limit: LIMIT,
      },
      skip: !id,
    }],
    awaitRefetchQueries: true,
  });

  const handleDismissBanner = async () => {
    try {
      await dismissBanner({
        variables: {
          projectId: id,
        },
      });
    } catch (ex) {
      captureException('HANDLE_DISMISS_BANNER_FAILED', ex);
    }
  };

  return (
    <Container>
      <Text>
        Set up your calendar for
        “
        {projectName}
        ”
        so participants can book time.
        <Link href={`/projects/${id}/schedule`}> Click here </Link>
        to go to the Schedule tab.
      </Text>
      <ContainerIcon>
        <IconClose
          name="close"
          onClick={handleDismissBanner}
        />
      </ContainerIcon>
    </Container>
  );
};

Banner.propTypes = {
  projectName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  userId: authentication.profile.user_id,
});

const enhance = compose(
  connect(mapStateToProps, null),
);

export default enhance(Banner);
